import {
  IESDPCaptainReportsStudent,
  IESDPCreateTeams,
  IESDPFreeTimeGraph,
  IESDPTeamIteration,
} from '@interfaces/IESDP';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { Action } from '@ngrx/store';

export enum EESDPChangesActions {
  CreateESDPTeamsRequest = '[ESDP] Create Teams Request',
  CreateESDPTeamsSuccess = '[ESDP] Create Teams Success',
  CreateESDPTeamsFailure = '[ESDP] Create Teams Failure',
  ClearCreateESDPTeams = '[ESDP] Clear Create Teams',

  CreateESDPTeamIterationRequest = '[ESDP] Create Team Iteration Request',
  CreateESDPTeamIterationSuccess = '[ESDP] Create Team Iteration Success',
  CreateESDPTeamIterationFailure = '[ESDP] Create Team Iteration Failure',
  ClearCreateESDPTeamIteration = '[ESDP] Clear Create Team Iteration',

  DeleteTeamIterationRequest = '[ESDP] Delete Team Iteration Request',
  DeleteTeamIterationSuccess = '[ESDP] Delete Team Iteration Success',
  DeleteTeamIterationFailure = '[ESDP] Delete Team Iteration Failure',
  ClearDeleteTeamIteration = '[ESDP] Clear Delete Team Iteration',

  UpdateIterationTimeRequest = '[ESDP] Update Iteration Time Request',
  UpdateIterationTimeSuccess = '[ESDP] Update Iteration Time Success',
  UpdateIterationTimeFailure = '[ESDP] Update Iteration Time Failure',
  ClearUpdateIterationTimeErrors = '[ESDP] Clear Update Iteration Time Errors',

  UpdateRolesIterationRequest = '[ESDP] Update Roles Iteration Request',
  UpdateRolesIterationSuccess = '[ESDP] Update Roles Iteration Success',
  UpdateRolesIterationFailure = '[ESDP] Update Roles Iteration Failure',
  ClearUpdateRolesIterationErrors = '[ESDP] Clear  Update Roles Iteration Errors',

  DeleteStudentFromTeamRequest = '[ESDP] Delete Student From Team Request',
  DeleteStudentFromTeamSuccess = '[ESDP] Delete Student From Team Success',
  DeleteStudentFromTeamFailure = '[ESDP] Delete Student From Team Failure',
  ClearDeleteStudentFromTeamErrors = '[ESDP] Clear Delete Student From Team Errors',

  AddStudentsToTeamRequest = '[ESDP] Add Student To Team Request',
  AddStudentsToTeamSuccess = '[ESDP] Add Student To Team Success',
  AddStudentsToTeamFailure = '[ESDP] Add Student To Team Failure',
  ClearAddStudentsToTeamErrors = '[ESDP] Clear Add Student To Team Errors',

  TransferStudentsToTeamRequest = '[ESDP] Transfer Students To Team Request',
  TransferStudentsToTeamSuccess = '[ESDP] Transfer Students To Team Success',
  TransferStudentsToTeamFailure = '[ESDP] Transfer Students To Team Failure',
  ClearTransferStudentsToTeamErrors = '[ESDP] Clear Transfer Students To Team Errors',

  ReturnStudentsToTeamRequest = '[ESDP] Return Student To Team Request',
  ReturnStudentsToTeamSuccess = '[ESDP] Return Student To Team Success',
  ReturnStudentsToTeamFailure = '[ESDP] Return Student To Team Failure',
  ClearReturnStudentsToTeamErrors = '[ESDP] Clear Return Student To Team Errors',

  ChangeTeamMentorRequest = '[ESDP] Change Team Mentor Request',
  ChangeTeamMentorSuccess = '[ESDP] Change Team Mentor Success',
  ChangeTeamMentorFailure = '[ESDP] Change Team Mentor Failure',
  ClearChangeTeamMentorErrors = '[ESDP] Clear Change Team Mentor Errors',

  AddTeamDocumentsRequest = '[ESDP] Add Team Documents Request',
  AddTeamDocumentsSuccess = '[ESDP] Add Team Documents Success',
  AddTeamDocumentsFailure = '[ESDP] Add Team Documents Failure',

  ClearAddTeamDocumentsErrors = '[ESDP] Clear Add Team Documents Errors',

  UpdateTeamDocumentRequest = '[ESDP] Update Team Document Request',
  UpdateTeamDocumentSuccess = '[ESDP] Update Team Document Success',
  UpdateTeamDocumentFailure = '[ESDP] Update Team Document Failure',

  ClearUpdateTeamDocumentErrors = '[ESDP] Clear Update Team Document Errors',

  DeleteTeamDocumentRequest = '[ESDP] Delete Team Document Request',
  DeleteTeamDocumentSuccess = '[ESDP] Delete Team Document Success',
  DeleteTeamDocumentFailure = '[ESDP] Delete Team Document Failure',

  ClearDeleteTeamDocumentErrors = '[ESDP] Clear Delete Team Document Errors',

  AddEsdpMaterialRequest = '[ESDP] Add Team Materials Request',
  AddEsdpMaterialSuccess = '[ESDP] Add Team Materials Success',
  AddEsdpMaterialFailure = '[ESDP] Add Team Materials Failure',
  ClearAddEsdpMaterial = '[ESDP] Clear Add Team Materials',

  DeleteTeamMaterialRequest = '[ESDP] Delete Team Material Request',
  DeleteTeamMaterialSuccess = '[ESDP] Delete Team Material Success',
  DeleteTeamMaterialFailure = '[ESDP] Delete Team Material Failure',
  ClearDeleteTeamMaterial = '[ESDP] Clear Delete Team Material',

  ActivateESDPReqeust = '[ESDP] Activate ESDP Request',
  ActivateESDPSuccess = '[ESDP] Activate ESDP Success',
  ActivateESDPFailure = '[ESDP] Activate ESDP Failure',
  ClearActivateESDPErrors = '[ESDP] Clear Activate ESDP Errors',

  UpdateIterationReviewRequest = '[ESDP] Update Iteration Review Request',
  UpdateIterationReviewSuccess = '[ESDP] Update Iteration Review Success',
  UpdateIterationReviewFailure = '[ESDP] Update Iteration Review Failure',
  ClearUpdateIterationReview = '[ESDP] Clear Update Iteration Review',

  SendFreeTimeGraphRequest = '[ESDP] Send Free Time Graph Request',
  SendFreeTimeGraphSuccess = '[ESDP] Send Free Time Graph Success',
  SendFreeTimeGraphFailure = '[ESDP] Send Free Time Graph Failure',
  ClearSendFreeTimeGraph = '[ESDP] Clear Send Free Time Graph',

  FreeTimeFormRemindLaterRequest = '[ESDP] Free Time Form Remind Later Request',
  FreeTimeFormRemindLaterSuccess = '[ESDP] Free Time Form Remind Later Success',
  FreeTimeFormRemindLaterFailure = '[ESDP] Free Time Form Remind Later Failure',
  ClearFreeTimeFormRemindLater = '[ESDP] Clear Free Time Form Remind Later',

  UpdateIterationStatusRequest = '[ESDP] Update Iteration Status Request',
  UpdateIterationStatusSuccess = '[ESDP] Update Iteration Status Success',
  UpdateIterationStatusFailure = '[ESDP] Update Iteration Status Failure',
  ClearUpdateIterationStatus = '[ESDP] Clear Update Iteration Status',

  UpdateIterationCaptainReportRequest = '[ESDP] Update Iteration Captain Report Request',
  UpdateIterationCaptainReportSuccess = '[ESDP] Update Iteration Captain Report Success',
  UpdateIterationCaptainReportFailure = '[ESDP] Update Iteration Captain Report Failure',
  ClearUpdateIterationCaptainReport = 'Clear [ESDP] Update Iteration Captain Report',

  OpenAccessReviewsRequest = '[ESDP] Open Access Reviews Request',
  OpenAccessReviewsSuccess = '[ESDP] Open Access Reviews Success',
  OpenAccessReviewsFailure = '[ESDP] Open Access Reviews Failure',
  ClearOpenAccessReviews = '[ESDP] Clear Open Access Reviews',

  AddHolidaysToTeamRequest = '[ESDP] Add Holidays To Team Request',
  AddHolidaysToTeamSuccess = '[ESDP] Add Holidays To Team Success',
  AddHolidaysToTeamFailure = '[ESDP] Add Holidays To Team Failure',
  ClearAddHolidaysToTeamErrors = '[ESDP] Clear Add Holidays To Team',

  UpdateTeamRequest = '[ESDP] Update Team Request',
  UpdateTeamSuccess = '[ESDP] Update Team Success',
  UpdateTeamFailure = '[ESDP] Update Team Failure',
  ClearUpdateTeam = '[ESDP] Clear Update Team',

  ChangeRoleToStudentRequest = '[ESDP] Change Role Request',
  ChangeRoleToStudentSuccess = '[ESDP] Change Role Success',
  ChangeRoleToStudentFailure = '[ESDP] Change Role Failure',
  ClearChangeRoleToStudent = '[ESDP] Clear Change Role',

  DeleteRoleToStudentRequest = '[ESDP] Delete Role Request',
  DeleteRoleToStudentSuccess = '[ESDP] Delete Role Success',
  DeleteRoleToStudentFailure = '[ESDP] Delete Role Failure',
  ClearDeleteRoleToStudent = '[ESDP] Clear Delete Role',
}

export class CreateESDPTeamsRequest implements Action {
  public readonly type = EESDPChangesActions.CreateESDPTeamsRequest;

  constructor(public data: IESDPCreateTeams[]) {}
}

export class CreateESDPTeamsSuccess implements Action {
  public readonly type = EESDPChangesActions.CreateESDPTeamsSuccess;
}

export class CreateESDPTeamsFailure implements Action {
  public readonly type = EESDPChangesActions.CreateESDPTeamsFailure;

  constructor(public errors: IFormErrors[]) {}
}

export class ClearCreateESDPTeams implements Action {
  public readonly type = EESDPChangesActions.ClearCreateESDPTeams;
}

export class CreateESDPTeamIterationRequest implements Action {
  public readonly type = EESDPChangesActions.CreateESDPTeamIterationRequest;

  constructor(
    public payload: { team_id: number; start_date?: string; end_date?: string }
  ) {}
}

export class CreateESDPTeamIterationSuccess implements Action {
  public readonly type = EESDPChangesActions.CreateESDPTeamIterationSuccess;
}

export class CreateESDPTeamIterationFailure implements Action {
  public readonly type = EESDPChangesActions.CreateESDPTeamIterationFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearCreateESDPTeamIteration implements Action {
  public readonly type = EESDPChangesActions.ClearCreateESDPTeamIteration;
}

export class DeleteESDPTeamIterationRequest implements Action {
  public readonly type = EESDPChangesActions.DeleteTeamIterationRequest;

  constructor(public payload: IESDPTeamIteration) {}
}

export class DeleteESDPTeamIterationSuccess implements Action {
  public readonly type = EESDPChangesActions.DeleteTeamIterationSuccess;
}

export class DeleteESDPTeamIterationFailure implements Action {
  public readonly type = EESDPChangesActions.DeleteTeamIterationFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteESDPTeamIteration implements Action {
  public readonly type = EESDPChangesActions.ClearDeleteTeamIteration;
}

export class UpdateESDPIterationTimeRequest implements Action {
  public readonly type = EESDPChangesActions.UpdateIterationTimeRequest;

  constructor(
    public id: number,
    public payload: { start_date: string; end_date: string }
  ) {}
}

export class UpdateESDPIterationTimeSuccess implements Action {
  public readonly type = EESDPChangesActions.UpdateIterationTimeSuccess;
}

export class UpdateESDPIterationTimeFailure implements Action {
  public readonly type = EESDPChangesActions.UpdateIterationTimeFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearUpdateESDPIterationTimeErrors implements Action {
  public readonly type = EESDPChangesActions.ClearUpdateIterationTimeErrors;
}

export class UpdateESDPIterationRolesRequest implements Action {
  public readonly type = EESDPChangesActions.UpdateRolesIterationRequest;

  constructor(
    public id: number,
    public payload: { captain: number; analysts: number[] }
  ) {}
}

export class UpdateESDPIterationRolesSuccess implements Action {
  public readonly type = EESDPChangesActions.UpdateRolesIterationSuccess;
}

export class UpdateESDPIterationRolesFailure implements Action {
  public readonly type = EESDPChangesActions.UpdateRolesIterationFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearUpdateESDPIterationRolesErrors implements Action {
  public readonly type = EESDPChangesActions.ClearUpdateRolesIterationErrors;
}

export class DeleteStudentFromESDPTeamRequest implements Action {
  public readonly type = EESDPChangesActions.DeleteStudentFromTeamRequest;

  constructor(public teamId: number, public students: number[]) {}
}

export class DeleteStudentFromESDPTeamSuccess implements Action {
  public readonly type = EESDPChangesActions.DeleteStudentFromTeamSuccess;
}

export class DeleteStudentFromESDPTeamFailure implements Action {
  public readonly type = EESDPChangesActions.DeleteStudentFromTeamFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteStudentFromESDPTeamErrors implements Action {
  public readonly type = EESDPChangesActions.ClearDeleteStudentFromTeamErrors;
}

export class AddStudentsToESDPTeamRequest implements Action {
  public readonly type = EESDPChangesActions.AddStudentsToTeamRequest;

  constructor(public teamId: number, public students: number[]) {}
}

export class AddStudentsToESDPTeamSuccess implements Action {
  public readonly type = EESDPChangesActions.AddStudentsToTeamSuccess;
}

export class AddStudentsToESDPTeamFailure implements Action {
  public readonly type = EESDPChangesActions.AddStudentsToTeamFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddStudentsToESDPTeamErrors implements Action {
  public readonly type = EESDPChangesActions.ClearAddStudentsToTeamErrors;
}

export class TransferStudentsToESDPTeamRequest implements Action {
  public readonly type = EESDPChangesActions.TransferStudentsToTeamRequest;

  constructor(
    public teamId: number,
    public payload: { team: string; users: number[] },
    public courseId?: number,
    public groupId?: number
  ) {}
}

export class TransferStudentsToESDPTeamSuccess implements Action {
  public readonly type = EESDPChangesActions.TransferStudentsToTeamSuccess;
}

export class TransferStudentsToESDPTeamFailure implements Action {
  public readonly type = EESDPChangesActions.TransferStudentsToTeamFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearTransferStudentsToESDPTeamErrors implements Action {
  public readonly type = EESDPChangesActions.ClearTransferStudentsToTeamErrors;
}

export class ReturnStudentsToESDPTeamRequest implements Action {
  public readonly type = EESDPChangesActions.ReturnStudentsToTeamRequest;

  constructor(public teamId: number, public students: number[]) {}
}

export class ReturnStudentsToESDPTeamSuccess implements Action {
  public readonly type = EESDPChangesActions.ReturnStudentsToTeamSuccess;
}

export class ReturnStudentsToESDPTeamFailure implements Action {
  public readonly type = EESDPChangesActions.ReturnStudentsToTeamFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearReturnStudentsToESDPTeamErrors implements Action {
  public readonly type = EESDPChangesActions.ClearReturnStudentsToTeamErrors;
}

export class ChangeESDPTeamMentorRequest implements Action {
  public readonly type = EESDPChangesActions.ChangeTeamMentorRequest;

  constructor(public teamId: number, public mentors: number[]) {}
}

export class ChangeESDPTeamMentorSuccess implements Action {
  public readonly type = EESDPChangesActions.ChangeTeamMentorSuccess;
}

export class ChangeESDPTeamMentorFailure implements Action {
  public readonly type = EESDPChangesActions.ChangeTeamMentorFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearChangeESDPTeamMentorErrors implements Action {
  public readonly type = EESDPChangesActions.ClearChangeTeamMentorErrors;
}

export class AddTeamDocumentsRequest implements Action {
  public readonly type = EESDPChangesActions.AddTeamDocumentsRequest;

  constructor(public data: FormData, public teamId?: number) {}
}

export class AddTeamDocumentsSuccess implements Action {
  public readonly type = EESDPChangesActions.AddTeamDocumentsSuccess;
}

export class AddTeamDocumentsFailure implements Action {
  public readonly type = EESDPChangesActions.AddTeamDocumentsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddTeamDocumentsErrors implements Action {
  public readonly type = EESDPChangesActions.ClearAddTeamDocumentsErrors;
}

export class UpdateTeamDocumentRequest implements Action {
  public readonly type = EESDPChangesActions.UpdateTeamDocumentRequest;

  constructor(
    public data: { content: string; title: string },
    public id: number
  ) {}
}

export class UpdateTeamDocumentSuccess implements Action {
  public readonly type = EESDPChangesActions.UpdateTeamDocumentSuccess;
}

export class UpdateTeamDocumentFailure implements Action {
  public readonly type = EESDPChangesActions.UpdateTeamDocumentFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearUpdateTeamDocumentErrors implements Action {
  public readonly type = EESDPChangesActions.ClearUpdateTeamDocumentErrors;
}

export class DeleteTeamDocumentRequest implements Action {
  public readonly type = EESDPChangesActions.DeleteTeamDocumentRequest;

  constructor(public id: number) {}
}

export class DeleteTeamDocumentSuccess implements Action {
  public readonly type = EESDPChangesActions.DeleteTeamDocumentSuccess;
}

export class DeleteTeamDocumentFailure implements Action {
  public readonly type = EESDPChangesActions.DeleteTeamDocumentFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteTeamDocumentErrors implements Action {
  public readonly type = EESDPChangesActions.ClearDeleteTeamDocumentErrors;
}

export class ActivateESDPRequest implements Action {
  public readonly type = EESDPChangesActions.ActivateESDPReqeust;

  constructor(public groupId: number) {}
}

export class ActivateESDPSuccess implements Action {
  public readonly type = EESDPChangesActions.ActivateESDPSuccess;
}

export class ActivateESDPFailure implements Action {
  public readonly type = EESDPChangesActions.ActivateESDPFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearActivateESDPErrors implements Action {
  public readonly type = EESDPChangesActions.ClearActivateESDPErrors;
}

export class UpdateESDPIterationReviewRequest implements Action {
  public readonly type = EESDPChangesActions.UpdateIterationReviewRequest;

  constructor(
    public id: number,
    public payload: {
      text?: string;
      points?: string;
      is_published?: boolean;
      currentId?: number;
    }
  ) {}
}

export class UpdateESDPIterationReviewSuccess implements Action {
  public readonly type = EESDPChangesActions.UpdateIterationReviewSuccess;
}

export class UpdateESDPIterationReviewFailure implements Action {
  public readonly type = EESDPChangesActions.UpdateIterationReviewFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearUpdateESDPIterationReview implements Action {
  public readonly type = EESDPChangesActions.ClearUpdateIterationReview;
}

export class UpdateESDPIterationStatusRequest implements Action {
  public readonly type = EESDPChangesActions.UpdateIterationStatusRequest;

  constructor(public id: number, public payload: { is_active: boolean }) {}
}

export class UpdateESDPIterationStatusSuccess implements Action {
  public readonly type = EESDPChangesActions.UpdateIterationStatusSuccess;
}

export class UpdateESDPIterationStatusFailure implements Action {
  public readonly type = EESDPChangesActions.UpdateIterationStatusFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearUpdateESDPIterationStatus implements Action {
  public readonly type = EESDPChangesActions.ClearUpdateIterationStatus;
}

export class UpdateESDPIterationCaptainReportRequest implements Action {
  public readonly type =
    EESDPChangesActions.UpdateIterationCaptainReportRequest;

  constructor(
    public id: number,
    public indexCurrentDay: number,
    public payload: IESDPCaptainReportsStudent[]
  ) {}
}

export class UpdateESDPIterationCaptainReportSuccess implements Action {
  public readonly type =
    EESDPChangesActions.UpdateIterationCaptainReportSuccess;
}

export class UpdateESDPIterationCaptainReportFailure implements Action {
  public readonly type =
    EESDPChangesActions.UpdateIterationCaptainReportFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearUpdateESDPIterationCaptainReport implements Action {
  public readonly type = EESDPChangesActions.ClearUpdateIterationCaptainReport;
}

export class SendFreeTimeGraphRequest implements Action {
  public readonly type = EESDPChangesActions.SendFreeTimeGraphRequest;

  constructor(public data: IESDPFreeTimeGraph, public userId: number) {}
}

export class SendFreeTimeGraphSuccess implements Action {
  public readonly type = EESDPChangesActions.SendFreeTimeGraphSuccess;
}

export class SendFreeTimeGraphFailure implements Action {
  public readonly type = EESDPChangesActions.SendFreeTimeGraphFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearSendFreeTimeGraph implements Action {
  public readonly type = EESDPChangesActions.ClearSendFreeTimeGraph;
}

export class FreeTimeFormRemindLaterRequest implements Action {
  public readonly type = EESDPChangesActions.FreeTimeFormRemindLaterRequest;

  constructor(public studentId: number) {}
}

export class FreeTimeFormRemindLaterSuccess implements Action {
  public readonly type = EESDPChangesActions.FreeTimeFormRemindLaterSuccess;
}

export class FreeTimeFormRemindLaterFailure implements Action {
  public readonly type = EESDPChangesActions.FreeTimeFormRemindLaterFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearFreeTimeFormRemindLater implements Action {
  public readonly type = EESDPChangesActions.ClearFreeTimeFormRemindLater;
}

export class OpenESDPAccessReviewsRequest implements Action {
  public readonly type = EESDPChangesActions.OpenAccessReviewsRequest;

  constructor(public groupId: number) {}
}

export class OpenESDPAccessReviewsSuccess implements Action {
  public readonly type = EESDPChangesActions.OpenAccessReviewsSuccess;
}

export class OpenESDPAccessReviewsFailure implements Action {
  public readonly type = EESDPChangesActions.OpenAccessReviewsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearOpenESDPAccessReviews implements Action {
  public readonly type = EESDPChangesActions.ClearOpenAccessReviews;
}

export class AddHolidaysToESDPTeamRequest implements Action {
  public readonly type = EESDPChangesActions.AddHolidaysToTeamRequest;

  constructor(
    public payload: { team: number; start_date: string; weeks: string }
  ) {}
}

export class AddHolidaysToESDPTeamSuccess implements Action {
  public readonly type = EESDPChangesActions.AddHolidaysToTeamSuccess;
}

export class AddHolidaysToESDPTeamFailure implements Action {
  public readonly type = EESDPChangesActions.AddHolidaysToTeamFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddHolidaysToESDPTeamErrors implements Action {
  public readonly type = EESDPChangesActions.ClearAddHolidaysToTeamErrors;
}

export class UpdateESDPTeamRequest implements Action {
  public readonly type = EESDPChangesActions.UpdateTeamRequest;

  constructor(public teamId: number, public data: { is_active?: boolean }) {}
}

export class UpdateESDPTeamSuccess implements Action {
  public readonly type = EESDPChangesActions.UpdateTeamSuccess;
}

export class UpdateESDPTeamFailure implements Action {
  public readonly type = EESDPChangesActions.UpdateTeamFailure;
}

export class ClearUpdateESDPTeam implements Action {
  public readonly type = EESDPChangesActions.ClearUpdateTeam;
}

export class AddEsdpMaterialRequest implements Action {
  public readonly type = EESDPChangesActions.AddEsdpMaterialRequest;

  constructor(public file: FormData, public teamId: number) {}
}

export class AddEsdpMaterialSuccess implements Action {
  public readonly type = EESDPChangesActions.AddEsdpMaterialSuccess;
}

export class AddEsdpMaterialFailure implements Action {
  public readonly type = EESDPChangesActions.AddEsdpMaterialFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddEsdpMaterials implements Action {
  public readonly type = EESDPChangesActions.ClearAddEsdpMaterial;
}

export class DeleteESDPTeamMaterialRequest implements Action {
  public readonly type = EESDPChangesActions.DeleteTeamMaterialRequest;

  constructor(public id: number, public fileId: number) {}
}

export class DeleteESDPTeamMaterialSuccess implements Action {
  public readonly type = EESDPChangesActions.DeleteTeamMaterialSuccess;
}

export class DeleteESDPTeamMaterialFailure implements Action {
  public readonly type = EESDPChangesActions.DeleteTeamMaterialFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteESDPTeamMaterial implements Action {
  public readonly type = EESDPChangesActions.ClearDeleteTeamMaterial;
}

export class ChangeRoleToStudentRequest implements Action {
  public readonly type = EESDPChangesActions.ChangeRoleToStudentRequest;

  constructor(
    public teamId: number,
    public student_id: number,
    public assigned_role: string
  ) {}
}
export class ChangeRoleToStudentSuccess implements Action {
  public readonly type = EESDPChangesActions.ChangeRoleToStudentSuccess;
}
export class ChangeRoleToStudentFailure implements Action {
  public readonly type = EESDPChangesActions.ChangeRoleToStudentFailure;

  constructor(public errors: IFormErrors) {}
}
export class ClearChangeRoleToStudentErrors implements Action {
  public readonly type = EESDPChangesActions.ClearChangeRoleToStudent;
}

export class DeleteRoleToStudentRequest implements Action {
  public readonly type = EESDPChangesActions.DeleteRoleToStudentRequest;

  constructor(
    public teamId: number,
    public student: number,
    public role: string
  ) {}
}
export class DeleteRoleToStudentSuccess implements Action {
  public readonly type = EESDPChangesActions.DeleteRoleToStudentSuccess;
}
export class DeleteRoleToStudentFailure implements Action {
  public readonly type = EESDPChangesActions.DeleteRoleToStudentFailure;

  constructor(public errors: IFormErrors) {}
}
export class ClearDeleteRoleToStudentErrors implements Action {
  public readonly type = EESDPChangesActions.ClearDeleteRoleToStudent;
}

export type ESDPChangesActions =
  | CreateESDPTeamsRequest
  | CreateESDPTeamsSuccess
  | CreateESDPTeamsFailure
  | ClearCreateESDPTeams
  | SendFreeTimeGraphRequest
  | SendFreeTimeGraphSuccess
  | SendFreeTimeGraphFailure
  | ClearSendFreeTimeGraph
  | FreeTimeFormRemindLaterRequest
  | FreeTimeFormRemindLaterSuccess
  | FreeTimeFormRemindLaterFailure
  | ClearFreeTimeFormRemindLater
  | CreateESDPTeamIterationRequest
  | CreateESDPTeamIterationSuccess
  | CreateESDPTeamIterationFailure
  | ClearCreateESDPTeamIteration
  | DeleteESDPTeamIterationRequest
  | DeleteESDPTeamIterationSuccess
  | DeleteESDPTeamIterationFailure
  | ClearDeleteESDPTeamIteration
  | UpdateESDPIterationTimeRequest
  | UpdateESDPIterationTimeSuccess
  | UpdateESDPIterationTimeFailure
  | ClearUpdateESDPIterationTimeErrors
  | UpdateESDPIterationRolesRequest
  | UpdateESDPIterationRolesSuccess
  | UpdateESDPIterationRolesFailure
  | ClearUpdateESDPIterationRolesErrors
  | DeleteStudentFromESDPTeamRequest
  | DeleteStudentFromESDPTeamSuccess
  | DeleteStudentFromESDPTeamFailure
  | ClearDeleteStudentFromESDPTeamErrors
  | AddStudentsToESDPTeamRequest
  | AddStudentsToESDPTeamSuccess
  | AddStudentsToESDPTeamFailure
  | ClearAddStudentsToESDPTeamErrors
  | TransferStudentsToESDPTeamRequest
  | TransferStudentsToESDPTeamSuccess
  | TransferStudentsToESDPTeamFailure
  | ClearTransferStudentsToESDPTeamErrors
  | ReturnStudentsToESDPTeamRequest
  | ReturnStudentsToESDPTeamSuccess
  | ReturnStudentsToESDPTeamFailure
  | ClearReturnStudentsToESDPTeamErrors
  | ChangeESDPTeamMentorRequest
  | ChangeESDPTeamMentorSuccess
  | ChangeESDPTeamMentorFailure
  | AddTeamDocumentsRequest
  | AddTeamDocumentsSuccess
  | AddTeamDocumentsFailure
  | ClearAddTeamDocumentsErrors
  | UpdateTeamDocumentRequest
  | UpdateTeamDocumentSuccess
  | UpdateTeamDocumentFailure
  | ClearUpdateTeamDocumentErrors
  | DeleteTeamDocumentRequest
  | DeleteTeamDocumentSuccess
  | DeleteTeamDocumentFailure
  | ClearDeleteTeamDocumentErrors
  | ClearChangeESDPTeamMentorErrors
  | ActivateESDPRequest
  | ActivateESDPSuccess
  | ActivateESDPFailure
  | ClearActivateESDPErrors
  | UpdateESDPIterationReviewRequest
  | UpdateESDPIterationReviewSuccess
  | UpdateESDPIterationReviewFailure
  | ClearUpdateESDPIterationReview
  | UpdateESDPIterationStatusRequest
  | UpdateESDPIterationStatusSuccess
  | UpdateESDPIterationStatusFailure
  | ClearUpdateESDPIterationStatus
  | UpdateESDPIterationCaptainReportRequest
  | UpdateESDPIterationCaptainReportSuccess
  | UpdateESDPIterationCaptainReportFailure
  | ClearUpdateESDPIterationCaptainReport
  | OpenESDPAccessReviewsRequest
  | OpenESDPAccessReviewsSuccess
  | OpenESDPAccessReviewsFailure
  | ClearOpenESDPAccessReviews
  | AddHolidaysToESDPTeamRequest
  | AddHolidaysToESDPTeamSuccess
  | AddHolidaysToESDPTeamFailure
  | ClearAddHolidaysToESDPTeamErrors
  | UpdateESDPTeamRequest
  | UpdateESDPTeamSuccess
  | UpdateESDPTeamFailure
  | ClearUpdateESDPTeam
  | AddEsdpMaterialRequest
  | AddEsdpMaterialSuccess
  | AddEsdpMaterialFailure
  | ClearAddEsdpMaterials
  | DeleteESDPTeamMaterialRequest
  | DeleteESDPTeamMaterialSuccess
  | DeleteESDPTeamMaterialFailure
  | ClearDeleteESDPTeamMaterial
  | ChangeRoleToStudentRequest
  | ChangeRoleToStudentSuccess
  | ChangeRoleToStudentFailure
  | ClearChangeRoleToStudentErrors
  | DeleteRoleToStudentRequest
  | DeleteRoleToStudentSuccess
  | DeleteRoleToStudentFailure
  | ClearDeleteRoleToStudentErrors;
